export const blockIconsTransportationTwoWheelerNew = (
	<span className='material-symbols-outlined'>two_wheeler</span>
);
